import { login, logout, getInfo, wxLogin, aliLogin } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    cart: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CART: (state, cart) => {
      state.cart = cart
    }
  },

  actions: {
    // 微信登录
    loginWechatAuth({ commit }, code) {
      const data = {
        code: code
      }
      return new Promise((resolve, reject) => {
        wxLogin(data)
          .then(response => {
            // 存用户信息，token
            // console.log('微信登录信息', res);
            const data = response.data
            const tokenStr = data.tokenHead + data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 支付宝登录
    loginAlipayAuth({ commit }, code) {
      const data = {
        code: code
      }
      return new Promise((resolve, reject) => {
        aliLogin(data)
          .then(response => {
            // 存用户信息，token
            console.log('支付宝登录信息', response);
            const data = response.data
            const tokenStr = data.tokenHead + data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js